exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-tasks {\n  height: 100px; }\n\n.tasks {\n  font-size: 20px; }\n\n.task-button:focus {\n  outline: 0 !important;\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/dashboard-my-oasis-detail/tasks-filter/tasks-filter.component.scss
// module id = ../../../../../src/app/dashboard-my-oasis/dashboard-my-oasis-detail/tasks-filter/tasks-filter.component.scss
// module chunks = main